import React, { useEffect, useRef, useState } from "react";
import { DownChevronIcon, InfoIcon, SendIcon } from "../Svg";
import { Button } from "../Button";
import _ from "lodash";
import cx from "classnames";
import { AIShowcase } from "../../store/models/AIShowcase";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ModalTypes, PredictionStatus } from "../../constants";
import Loader from "../Loader";
import UIState, { selectMobileLayout } from "../../store/UIState";
import { createSelector } from "reselect";
import { ImageInput } from "../form/ImageInput";
import { ShowcaseGallery } from "./ShowcaseGallery";
import { getUrlFromPath } from "../../store/models/Showcases/ShowcaseSketchApi";
import {
  AiOndemandApi, PREDICTION_STARTED, PREDICTION_STOPPED, selectApiKeys,
  selectPredictionId, selectPredictionStatus
} from "../../store/models/AiOndemandApi";
import { extractErrorText, getOndemandErrorMsg, readFileAsDataURL } from "../../utils";
import { selectCurrentUser } from "../../store/models/User";
import { HostedImgToImgModelNames, ImageToImageModels } from "../../constants/image-to-image-models";
import { selectOndemandModels } from "../../store/models/Ai";
import { useParams } from "react-router";


const TextLoadingItem = ({ loadingData, elapsedTime, predictionStatus }) => {
  const isLoadingPrediction = predictionStatus === PredictionStatus.IN_PROGRESS
    || predictionStatus === PredictionStatus.STARTED;
  if (!loadingData && !isLoadingPrediction) return <></>;

  if (loadingData && loadingData.msg === 'estimation') {
    return (
      <div className={cx("ResultBox")}>
        <div className={"ResultBox__Loading"}>
          <div className={"ResultBox__Loading__TopWrapper"}>
            Scheduled | {elapsedTime}s / {loadingData?.rank_eta?.toFixed(0) ?? '?'}s
          </div>

          <div className={"ResultBox__Loading__CenterWrapper"}>
            <Loader size={"small"} color={"green"} /> Waiting for available slot...
          </div>

          <div className={"ResultBox__Loading__BottomWrapper"}>Number of jobs ahead of you: <span
            style={{ color: '#ffffff' }}>{loadingData.rank + 1}</span></div>
        </div>
      </div>)
  }

  if ((loadingData && loadingData.msg === 'process_starts')
    || isLoadingPrediction) {
    return (<div className={cx("ResultBox")}>

      <div className={"ResultBox__Loading"}>

        <div className={"ResultBox__Loading__TopWrapper"}>
          Processing | {elapsedTime}s / {loadingData?.eta?.toFixed(0) ?? '?'}s
        </div>

        <div className={"ResultBox__Loading__CenterWrapper"}>
          <Loader color={"green"} />
        </div>

        <div className={"ResultBox__Loading__BottomWrapper"}>Image captions generation in progress...</div>
      </div>
    </div>)
  }
}

const PromptItem = ({ message }) => {
  const [paramsOpened, setParamsOpened] = useState(false);

  const onToggleParams = () => {
    setParamsOpened(!paramsOpened);
  }

  return (
    <div className={cx("PromptContainerRoot")}>
      <div className={"PromptContainer"}>
        <div className={"PromptContainer__Visible"}>
          <div className="PromptContainer__Left">
            <div className={"PromptContainer__PromptLabel"}>Prompt</div>
          </div>
          <div className={"PromptContainer__Right"}>
            {_.map(message.imageUrls, (imageUrl, index) => {
              return (<a key={index} href={imageUrl} target={"_blank"}>
                <img src={imageUrl} />
              </a>)
            })}
          </div>
        </div>
        {!_.isEmpty(message.params) && <div className={"PromptContainer__BottomWrapper"}>
          <div className={`PromptContainer__ParamsButton ${paramsOpened && "open"}`}
            onClick={onToggleParams}>More parameters <DownChevronIcon /></div>
        </div>}
        {paramsOpened &&
          <div className={"PromptContainer__Params"}>
            <pre>{JSON.stringify(message.params, null, 2)}</pre>
          </div>}
      </div>
    </div>)

}


const TextItem = ({ item }) => {
  return (
    <div className={cx("ResultBox")}>
      <div className={"ResultBox__Text"}>
        <div className={"ResultBox__Text--label"}>
          Generated image captions. Here is the result:
        </div>
        "{item.text}"
      </div>
    </div>
  )
}

const ImageInputInstructions = ({ galleryLabel, icon }) => {

  return (<>
    {icon && <div>{icon}</div>}
    <div><span className={"ImageInput__Label--Green"}>Upload {galleryLabel}</span></div>
    <div>or</div>
    <div>drag image here</div>
  </>)
}


const selector = createSelector(
  selectMobileLayout,
  selectApiKeys,
  selectPredictionStatus,
  selectPredictionId,
  selectCurrentUser,
  (isMobile, apiKeys, predictionStatus, predictionId, curUser) => ({
    isMobile,
    apiKeys,
    predictionStatus,
    predictionId,
    curUser
  }
  ))

let intervalId = null;

export const ShowcaseImageToText = ({ className, mName }) => {
  const dispatch = useDispatch();

  const {
    isMobile,
    apiKeys,
    predictionStatus,
    predictionId,
    curUser
  } = useSelector(state => selector(state));
  const apiKey = _.get(apiKeys, '0.key');
  const model = { name: 'Blip' }
  const modelData = _.find(ImageToImageModels, model => model.label === "Blip")

  const [imageUploading, setImageUploading] = useState(false)
  const [loadingData, setLoadingData] = useState(null)
  const [error, setError] = useState(null)
  const [elapsedTime, setElapsedTime] = useState(0)
  const [currentImageUrls, setCurrentImageUrls] = useState({})
  const [messages, setMessages] = useState([])
  const [currentImageFiles, setCurrentImageFiles] = useState({})

  const chatboxRef = React.createRef();
  const showcaseUrl = model.urls || "https://imagetoimam868dejl8m-dc578bd5abdb2659.tec-s10.onthetaedgecloud.com";
  const params = useParams();
  const { projectId, id } = params;
  const { templates, services } = useSelector(state => selectOndemandModels(state, projectId));
  const template = templates.find(s => s.id === id);
  const service = services.find(s => s.template_id === template.id);
  let samples = {};
  if (service) {
    let prediction = _.get(Object.values(_.get(service, 'predictions')), '0');
    let instructions = _.get(prediction, 'instructions');
    if (instructions) {
      try {
        let instructionsJson = JSON.parse(instructions);
        samples = _.get(instructionsJson, 'samples')
      } catch (e) {
        console.log('e:', e.message);
      }
    }
  }

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, []);




  const onGenerate = async (event) => {
    setError(null)
    event.preventDefault();

    try {
      setMessages([...messages, {
        type: 'prompt',
        imageUrls: _.values(currentImageUrls),
      }, { type: 'loading' }])
      onScrollToBottom()

      startStopwatch();

      if (mName) {
        await onHostedGenerate();
      }
    } catch (e) {
      toast.error(e.message)
      if (mName) setMessages((messages) => messages.slice(0, -2))
      console.error(e)
    }
  };

  const onHostedGenerate = async () => {
    dispatch({ type: PREDICTION_STARTED });
    let hasPreSignedUrls = false;
    let imagePresignedUrls = {};
    try {
      for (let name of Object.keys(currentImageFiles)) {
        let url = _.get(currentImageFiles, `${name}.url`);
        if (url) {
          imagePresignedUrls[name] = {};
          imagePresignedUrls[name].filename = url;
        } else {
          let file = _.get(currentImageFiles, `${name}.file`);
          if (!hasPreSignedUrls) {
            await fetchPreSignUrl();
            hasPreSignedUrls = true;
          }
          await dispatch(AiOndemandApi.actions.uploadImageToBucket(file, _.get(imagePresignedUrls, `${name}.presigned_url`)));
        }
      }
      const params = {};
      params["input_img"] = _.get(imagePresignedUrls, 'input_img.filename');
      let res
      if (mName === 'blip') {
        res = await dispatch(AiOndemandApi.actions.startHostedPredict(params, mName, apiKey));
      }
      const outputText = _.get(res, 'body.infer_requests.0.output.text');
      if (outputText) {
        setLoadingData(null)
        stopInterval()
        setMessages((messages) => [...messages.slice(0, -1), { type: 'result', text: outputText }])
        onScrollToBottom();
      } else if (res) {
        const errMsg = _.get(res, 'body.infer_requests.0.error_message');
        onError(errMsg === 'null' ? null : errMsg);
      }


      async function fetchPreSignUrl() {
        if (!mName || !apiKey) return;

        let res = await dispatch(AiOndemandApi.actions.presignUrl('blip', null, apiKey));
        switch (modelData.name) {
          case 'blip':
            if (!imagePresignedUrls["input_img"])
              imagePresignedUrls["input_img"] = _.get(res, "input_img");
            break;
          default:
            break;
        }
      }
    } catch (e) {
      dispatch({ type: PREDICTION_STOPPED });
      onError(getOndemandErrorMsg(e.message, curUser));
    }
  }

  const onSelectGalleryImage = async (itemIndex, name) => {
    const gallery = _.find(modelData.galleries, gallery => gallery.name === name)
    // const imageUrl = gallery.isLocal ? gallery.paths[itemIndex] : `${showcaseUrl}${gallery.paths[itemIndex]}`
    const imageUrl = _.get(samples, `${gallery.name}`)
      ? _.get(samples, `${gallery.name}.${itemIndex}`)
      : (gallery.isLocal
        ? gallery.paths[itemIndex]
        : `${showcaseUrl}${gallery.paths[itemIndex]}`);

    setCurrentImageUrls({
      ...currentImageUrls,
      [name]: imageUrl
    })
    if (!mName) return;
    setCurrentImageFiles({
      ...currentImageFiles, [name]: { url: imageUrl }
    })
  }



  const onImageSelected = async (file, name) => {
    if (!file) return;

    try {
      setImageUploading(true)
      let imageUrl;
      if (!mName) {
        const imagePath = await dispatch(AIShowcase.actions.uploadImage(file, showcaseUrl))
        imageUrl = getUrlFromPath(imagePath, showcaseUrl)
      } else {
        imageUrl = await readFileAsDataURL(file);
        setCurrentImageFiles({
          ...currentImageFiles, [name]: { file: file }
        })
      }

      setCurrentImageUrls({
        ...currentImageUrls, [name]: imageUrl
      })
      setImageUploading(false)
    } catch (e) {
      console.log('error:', e.message);
      setImageUploading(false)
      toast.error("Failed to upload image")
    }
  }

  const onPredictEvent = (event) => {
    switch (event.msg) {
      case 'estimation':
        setLoadingData(event)
        break;
      case 'process_starts':
        setLoadingData(loadingData => ({ ...loadingData, msg: 'process_starts' }))
        break;
      case 'process_completed':
        try {
          if (event.success) {
            setLoadingData(null)
            stopInterval()
            setMessages((messages) => [...messages.slice(0, -1), { type: 'result', text: event.output.data[0].url }])
            onScrollToBottom()
          } else {
            onError("Failed to generate")
          }
        } catch (e) {
          onError("Failed to generate: " + e.message)
        }
        break;
      case 'error':
      case 'unexpected_error':
        onError(event.error)
        break;
    }
  }

  const onError = (error) => {
    setLoadingData(null)
    setMessages((messages) => messages.slice(0, -2))
    stopInterval()
    setError(error ?? "Failed to generate. Try again later")
    error = extractErrorText(error)
    toast.error(error ?? "Failed to generate. Try again later")
  }

  const startStopwatch = () => {

    if (intervalId) {
      stopInterval()
    }

    const startTime = new Date().getTime()

    intervalId = setInterval(() => {
      const currentTime = new Date().getTime()
      setElapsedTime(((currentTime - startTime) / 1000).toFixed(0))
    }, 1000)

  }

  const stopInterval = () => {
    clearInterval(intervalId)
    intervalId = null
    setElapsedTime(0)
  }

  const onStopGenerating = (event) => {
    event.preventDefault();

    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: "Stop generating",
      message: "Are you sure you want to stop the ongoing generation?",
      onConfirm: onConfirmStopGenerating,
      confirmLabel: "Yes",
      cancelLabel: "No",
      size: 's'
    }))
  }

  const onConfirmStopGenerating = () => {
    stopInterval()
    setLoadingData(null)
    setMessages((messages) => messages.slice(0, -2))
    if (mName) {
      dispatch(AiOndemandApi.actions.stopHostedPredict(predictionId, apiKey));
    } else {
      dispatch(AIShowcase.actions.stopGeneration())
    }
  }

  const onClear = () => {
    setCurrentImageUrls({})
  }

  const onRemoveImage = (name) => {
    setCurrentImageUrls(_.omit(currentImageUrls, name))
  }

  const onScrollToBottom = () => {
    if (!isMobile) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
        if (!_.isNil(chatboxRef) && !_.isNil(chatboxRef.current)) {
          chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
      }, 200)
    }
  }

  return (
    <div className={cx("ShowcaseImageToText", className)}>
      <div className="ShowcaseImageToText__container">
        <div className={"ShowcaseImageToText__LeftSide"}>
          <div className={"SidePanel"}>
            <form className="SidePanel__form">
              <div className={"SidePanel__ImageInputs"}>
                {_.map(modelData.galleries, (gallery, index) => {
                  const currentImageUrl = currentImageUrls[gallery.name];
                  let galleryImages = _.get(samples, `${gallery.name}`)
                    ? _.get(samples, `${gallery.name}`)
                    : (gallery.isLocal
                      ? gallery.paths
                      : _.map(gallery.paths, (path) => `${showcaseUrl}${path}`))


                  return (<>
                    <ImageInput key={`image-input-${index}`}
                      value={currentImageUrl}
                      name={gallery.name}
                      label={gallery.label}
                      onChange={onImageSelected}
                      onRemove={onRemoveImage}
                      formats={"image/jpeg, image/jpg, image/png"}
                      instructions={<ImageInputInstructions galleryLabel={gallery.label} />}>
                      <div className={"ImageInput__LeftBadge"}>{gallery.label}</div>
                    </ImageInput>
                    {(isMobile || mName) &&
                      <ShowcaseGallery
                        key={`gallery-${index}`}
                        images={galleryImages}
                        title={gallery.galleryLabel}
                        onClick={onSelectGalleryImage}
                        name={gallery.name} />
                    }
                  </>)
                })}

              </div>

              <div className={"SidePanel__Examples"}>
                {!isMobile && !mName && _.map(modelData.galleries, (gallery, index) => {
                  return (<ShowcaseGallery key={`gallery-${index}`}
                    images={gallery.isLocal ? gallery.paths : _.map(gallery.paths, (path) => `${showcaseUrl}${path}`)}
                    title={gallery.galleryLabel}
                    onClick={onSelectGalleryImage}
                    name={gallery.name} />)
                })}
              </div>

              <div className={"SidePanel__ActionButtons"}>
                <Button
                  title={"Clear"}
                  color={"grey"}
                  className="SidePanel__ActionButtons__Button SidePanel__ActionButtons__Button"
                  disabled={_.size(currentImageUrls) === 0}
                  onClick={onClear}
                />

                {(loadingData || predictionStatus === PredictionStatus.IN_PROGRESS)
                  ? <Button
                    title={"Stop generating"}
                    onClick={onStopGenerating}
                    className="SidePanel__ActionButtons__Button--Primary"
                    color={"red"}
                  />
                  : <Button
                    title={"Generate"}
                    onClick={onGenerate}
                    loading={imageUploading}
                    icon={imageUploading ? null : <SendIcon />}
                    className="SidePanel__ActionButtons__Button SidePanel__ActionButtons__Button--Primary"
                    color={"green"}
                    disabled={!_.isNil(loadingData)
                      || _.size(currentImageUrls) < _.size(modelData.galleries)
                      || predictionStatus === PredictionStatus.STARTED} />}
              </div>

            </form>

          </div>
        </div>

        <div className={cx("ShowcaseImageToText__RightSide")}>
          {error && <div className={"ErrorMessage"}>{error}</div>}

          <div className={"MessagesWrapper"} ref={chatboxRef}>
            {!_.isEmpty(messages) && messages.map((item, index) => {
              switch (item.type) {
                case 'prompt':
                  return (<PromptItem key={index} message={item} />)
                case 'loading':
                  return (<TextLoadingItem key={index} loadingData={loadingData} elapsedTime={elapsedTime} predictionStatus={predictionStatus} />)
                case 'result':
                  return (<TextItem key={index} item={item} />)
              }
            })}
          </div>

        </div>
      </div>

    </div >
  );
}